// extracted by mini-css-extract-plugin
export default {"price":"u--z","onSale":"v--z","msrpLabelPrice":"w--z","msrpLabel":"x--z","originalPrice":"y--z","percentOff":"z--z"};